<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{NAT_NAME}} ({{FAC_NAME}})</td>
                               <th class="listHeader tableLinerT" style="width:20%">Approval User</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{INS_USR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Model</th>
                               <td class="text-left pl-5">{{EBK_MODEL_NAME}}</td>
                               <th class="listHeader" >Vehicle Identification Number</th>
                               <td class="text-left pl-5">{{EBK_IDTFY_NUMS}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">VCU ID</th>
                               <td class="text-left pl-5">{{VCU_ID}}</td>
                               <th class="listHeader">MCU ID</th>
                               <td class="text-left pl-5">{{MCU_ID}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Battery ID 1</th>
                               <td class="text-left pl-5">{{CELL_ID1}}</td>
                               <th class="listHeader">Battery ID 2</th>
                               <td class="text-left pl-5">{{CELL_ID2}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Status</th>
                               <td class="tableLinerB text-left pl-5">{{CTR_INFO}}</td>
                               <th class="listHeader tableLinerB">Registration Date</th>
                               <td class="tableLinerB text-left pl-5">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Contact Info</h3>
                        <v-simple-table>
                            <tbody>
                            <tr>
                                <th class="listHeader tableLinerT" style="width:20%">Classification</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%" v-if="CTR_USR_TYPE==1">B2C</td>
                                <td class="tableLinerT text-left pl-5" style="width:30%" v-if="CTR_USR_TYPE==2">B2B</td>
                                <th class="listHeader tableLinerT" style="width:20%">Vehicle Number</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%">{{CTR_EBK_NUM}}</td>
                            </tr>
                            <tr v-if="CTR_USR_TYPE==2">
                                <th class="listHeader">Company</th>
                                <td class="text-left pl-5">{{CTR_USR_COMPANY_NAME}}</td>
                                <th class="listHeader" >Corporate Registration Number </th>
                                <td class="text-left pl-5">{{CTR_USR_COMPANY_NUM}}</td>
                            </tr>
                            <tr>
                                <th class="listHeader">Name</th>
                                <td class="text-left pl-5">{{CTR_USR_NM}}</td>
                                <th class="listHeader">Birth</th>
                                <td class="text-left pl-5">{{CTR_USR_BIRTH}}</td>
                            </tr>
                            <tr>
                                <th class="listHeader">Tel</th>
                                <td class="text-left pl-5">{{CTR_USR_TEL}}</td>
                                <th class="listHeader">Phone</th>
                                <td class="text-left pl-5">{{CTR_USR_PHONE}}</td>
                            </tr>
                            <tr>
                                <th class="listHeader" >Email</th>
                                <td class="text-left pl-5" colspan="3">{{CTR_USR_EMAIL}}</td>
                            </tr>
                            <tr>
                                <th class="listHeader">Address</th>
                                <td class="text-left pl-5" colspan="3">
                                    {{CTR_USR_POST}}&nbsp;{{CTR_USR_ADDR1}}&nbsp;{{CTR_USR_ADDR2}}
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Registration Date</th>
                                <td class="tableLinerB text-left pl-5">{{CTR_DT}}</td>
                                <th class="listHeader">Expiration Date</th>
                                <td class="tableLinerB text-left pl-5">{{CTR_EXP_DTM}}</td>
                            </tr>
                            
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <div class="d-flex flat ">
                            <div class="mr-auto align-self-center"><h3>History</h3></div>
                            <div ><v-btn icon color="primary" @click="regOpenHistory"><v-icon>mdi-pencil-plus</v-icon></v-btn></div>
                        </div>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader text-center" style="width:20%;">Date</th>
                                    <th class="listHeader tableLinerR text-center">Memo</th>
                                </tr>
                                <tr v-for="(item) in historyList" :key="item.HIS_SEQ">
                                    <td class="rowList tableLinerR tableLinerB">{{item.INS_DTM}}</td>
                                    <td class="rowList tableLinerB text-left pl-5">{{item.CONT}}</td>
                                </tr>
                                <tr v-if="emptyHistoryFlag==true">
                                    <td colspan="11" class="tableLinerB" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="pa2 my-5">
                            <div>
                                <div class="text-center">
                                    <v-pagination
                                    v-model="page"
                                    :length="pagelength"
                                    ></v-pagination>
                                </div>
                            </div>
                        </div>

                            <div class="d-flex justify-space-between dense pa-0">
                                <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn dark class="registerBtn ml-2 px-6" @click="editInfo()">Edit</v-btn>
                            </div>
                            </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <div class="text-center pb-0 mb-0" >
            <v-form ref="form" v-model="formValid" lazy-validation >
            <v-dialog v-model="historyRegFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                       
                        <span>History Register</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="width:30%;height:40px !important;">작성자</th>
                                    <td class="tableLinerT text-left pl-5" style="height:40px !important;">admin</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="height:40px !important;">작성일</th>
                                    <td class="text-left pl-5" style="height:30px !important;">{{today}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class=" tableLinerB">
                                        <v-textarea
                                        outlined
                                        v-model="histroyCont"
                                        :rules="historyContRules"
                                        class="py-5"
                                        :counter="max"
                                        no-resize
                                        required
                                        ></v-textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions class="justify-end py-5 pr-10">
                        <v-btn color="red lighten-2" style="color:#fff"  @click="closeHistoryDialog">cancel</v-btn>
                        <v-btn color="primary"  @click="addHistory()">save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </v-form>
        </div>

      
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover {background-color: transparent !important;
}
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'VehicleDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"1", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ {text: 'Home', disabled: true,},{text: 'Vehicle', disabled: true,},{ text: 'Contract Management', disabled: true,},{ text: 'Contract List', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [
              {
                items: [
                  { title: 'Vehicle List', nums:11, href:'/Vehicle', icons:'mdi-format-list-bulleted' },
                  { title: 'New Registration', nums:12, href:'/VehicleWrite', icons:'mdi-lead-pencil' },
                ],
                title: 'Vehicle Management', nums: '1'
              },
              {
                items: [
                  { title: 'Contract List',nums:21, href:'/VehicleRLS', icons:'mdi-format-list-bulleted' },
                  { title: 'New Contract Registration', nums:22, href:'/VehicleRLS2', icons:'mdi-lead-pencil' },
                ],
                title: 'Contract Management', nums: '2'
              },
            ], 
            schEbkSeq:'',
            EBK_SEQ: "", NAT_NAME: "",FAC_NAME: "",EBK_MODEL_NAME: "",EBK_IDTFY_NUMS: "",
            VCU_ID: "",MCU_ID: "",CELL_ID1: "",CELL_ID2: "",APRV_STATUS: "",INS_DTM: "",INS_USR_ID: "",INS_USR: "",
            CONT1:"", CONT2:"", CONT3:"", CONT4:"",
            APRV_USR_ID: "",APRV_USR: "",APRV_DTM: "", APRV_INFO:"",

            CTR_USR_COUNTRY_CODE:"", CTR_USR_COUNTRY:"", CTR_USR_TYPE: "",
            CTR_USR_NM: "", CTR_USR_COMPANY_NAME:"", CTR_USR_COMPANY_NUM:"", CTR_DT:"", CTR_USR_BIRTH:"",
            CTR_USR_POST:"", CTR_USR_ADDR1:"", CTR_USR_ADDR2:"", CTR_USR_TEL: "", CTR_USR_PHONE: "", CTR_USR_EMAIL: "", CTR_STATUS: "", CTR_EBK_NUM: "", CTR_INFO: "", CTR_EXP_DTM: "",

            page:1, pagelength:1,
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            today: new Date().toISOString().substr(0, 10),
            histroyCont:"",
            emptyFlag:true,emptyHistoryFlag:true,historyRegFlag:false, historyList:[],
            historyContRules: [
                v => !!v || 'content is required',
                v => v.length <= 100 || 'content must be less than 100 characters',
                
            ],
            max:100, formValid:false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.ebkSeq);
        this.schEbkSeq = this.$route.params.ebkSeq;
        if(this.schEbkSeq == '' || this.schEbkSeq == undefined ) {
            this.schEbkSeq = localStorage.getItem("ebkSeq");

        } 

        if(this.schEbkSeq != '') {
            this.getInfo();
            this.getHistory();
        }
        window.scrollTo(0, 0);
    },

    methods : {
    
        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "ebkSeq": this.schEbkSeq
                })
            };
            
            fetch('http://e3.ideasell.kr/API/OFFICE/eBikeRLS.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    this.EBK_SEQ = json.EBK_SEQ; this.NAT_NAME = json.NAT_NAME; this.FAC_NAME = json.FAC_NAME; 
                    this.EBK_MODEL_NAME = json.EBK_MODEL_NAME; this.EBK_IDTFY_NUMS = json.EBK_IDTFY_NUMS;
                    this.VCU_ID = json.VCU_ID; this.MCU_ID = json.MCU_ID; this.CELL_ID1 = json.CELL_ID1; this.CELL_ID2 = json.CELL_ID2; 
                    this.APRV_STATUS = json.APRV_STATUS;
                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;

                    this.selectInsUsr = this.INS_USR_ID;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; this.APRV_DTM = json.APRV_DTM;
                    this.APRV_INFO = json.APRV_INFO;

                    this.CTR_USR_COUNTRY_CODE = json.CTR_USR_COUNTRY_CODE;
                    this.CTR_USR_COUNTRY = json.CTR_USR_COUNTRY;
                    this.CTR_USR_TYPE = json.CTR_USR_TYPE;
                    this.CTR_USR_NM = json.CTR_USR_NM;
                    this.CTR_USR_COMPANY_NAME = json.CTR_USR_COMPANY_NAME;
                    this.CTR_USR_COMPANY_NUM = json.CTR_USR_COMPANY_NUM;
                    this.s_date = this.CTR_DT = json.CTR_DT;
                    this.e_date = this.CTR_EXP_DTM = json.CTR_EXP_DTM;
                    this.CTR_USR_BIRTH = json.CTR_USR_BIRTH;
                    this.CTR_USR_POST = json.CTR_USR_POST;
                    this.CTR_USR_ADDR1 = json.CTR_USR_ADDR1;
                    this.CTR_USR_ADDR2 = json.CTR_USR_ADDR2;
                    this.CTR_USR_TEL = json.CTR_USR_TEL;
                    this.CTR_USR_PHONE = json.CTR_USR_PHONE;
                    this.CTR_USR_EMAIL = json.CTR_USR_EMAIL;
                    this.CTR_STATUS = json.CTR_STATUS;
                    this.CTR_EBK_NUM = json.CTR_EBK_NUM;
                    this.CTR_INFO = json.CTR_INFO;
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
        
        regOpenHistory() {
            this.histroyCont = "";
            this.historyRegFlag = true;
        },

        getHistory() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "dvcSeq": this.schEbkSeq
                    , "dvcType": 5
                })
            };
            
            fetch('http://e3.ideasell.kr/API/OFFICE/shareHistory.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.historyList = json.list;
              
                    this.emptyHistoryFlag = false;
                } else {
                   this.historyList = [];
                    this.emptyHistoryFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        addHistory() {
            this.validate();
            if( this.histroyCont == "" || this.histroyCont < 10 || this.histroyCont.length > 100 ) {
                alert('Please enter more than 10 characters and less than 100 characters');
                this.formValid = false;
            }
            //console.log(this.formValid);
            
            if(this.formValid === true) {
                var  requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "C"
                        , "dvcSeq": this.schEbkSeq
                        , "cont": this.histroyCont
                        , "dvcType": 5
                    })
                };
                
                fetch('http://e3.ideasell.kr/API/OFFICE/shareHistory.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json.result );
                    if(json.result == "success") {
                        this.getHistory();
                        this.histroyCont = '';
                        this.historyRegFlag = false;
                    } 
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            } else {
                this.resetValidation();
            }
            
        },
        validate () {
            //alert('a');
            this.$refs.form.validate();
        },

        resetValidation () {
            //alert('b');
            this.$refs.form.resetValidation();
        },

        closeHistoryDialog() {
            this.histroyCont = "";
            this.historyRegFlag = false;
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.histroyCont = "";
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'VehicleRLS'});
        },

        editInfo() {
            localStorage.setItem("schEbkSeq", this.schEbkSeq);
            localStorage.setItem("asyncActType", "U");
            this.$router.push({ name: 'VehicleRlsWrite', params: { schEbkSeq: this.schEbkSeq, asyncActType: "U" }})
        }

    }

}
</script>
